import { axiosApi } from "../../../api/dbAxios";

export const fetchRightList = async () => {
  try {
    const response = await axiosApi.get(`/rights/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching rights list:", error);
    return [];
  }
};
